(function () {
    'use strict';

    angular
        .module('app')
        .controller('PatternCreateController', PatternCreateController);


    function PatternCreateController($scope, $rootScope, $filter, $state, $stateParams, cfpLoadingBar,
        PatternService, SeasonService, UserService, BriefService, WorkflowService, toaster, SharedData) {

        var model = this;
        model.isDisabled = true;
        model.parentPatternSeasonalId = 0;
        model.briefSeasonalId = 0;
        model.briefId = 0;
        model.radioValue = "";
        model.newPatternSeason = {};
        model.PatternCreate = "";
        model.pageNumber = 1;
        model.pageSize = 50;

        $scope.parentPatternSeasonalId = $stateParams.parentPatternSeasonalId || 0;
        $scope.briefSeasonalId = $stateParams.briefSeasonalId || 0;

        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }

        angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
            if (userPermissionRow[0] == 4) {
                if (userPermissionRow[1] == 3) {
                    model.PatternCreate = true;
                }
                if (userPermissionRow[1] == 2) {
                    model.PatternEdit = true;
                }
            }
        });

        if (model.PatternCreate !== true) {
            $state.go('permissionDenied');
        }

        var briefSeasonalId = $stateParams.briefSeasonalId;
        if (briefSeasonalId) {
            model.briefSeasonalId = briefSeasonalId; // Create Pattern from Brief
            model.newPatternSeason.selectedSeason = briefSeasonalId;
        }

        if ($stateParams.parentPatternSeasonalId) {
            model.parentPatternSeasonalId = $stateParams.parentPatternSeasonalId; // Copy Pattern
        }

        function getBrands() {
            SharedData.getUserDefaults().then(function (response) {
                if (response) {
                    cfpLoadingBar.complete();
                    model.brands = response.brands;
                    model.seasons = response.seasons;
                    model.newPatternSeason.selectedBrand = response.brandId;
                    model.newPatternSeason.selectedSeason = response.seasonId;

                    if (response.brandId) {
                        model.selectBrand(response.brandId);
                    }

                    if (response.seasonId) {
                        model.loadBriefs(true);
                    }
                }
            });
        }

        function getSeasonsByBrand(brandId, defaultVal) {
            SeasonService.getSeasonsByBrand(brandId).then(function (data) {
                model.seasons = data;
                if (typeof defaultVal !== "undefined") {
                    angular.forEach(model.seasons, function (seasonRow) {
                        if (seasonRow.SeasonId == defaultVal) {
                            model.newPatternSeason.selectedSeason = seasonRow;
                        }
                    });
                }
            });
        }

        function getUsersByBrand(brandId) {
            UserService.getUsersByBrand(brandId).then(function (data) {
                model.users = data;
            });
        }

        function getWFGroups(brandId, defaultVal) {
            WorkflowService.getWFGroups(brandId, 3).then(function (data) {
                model.groups = data;
                if (typeof defaultVal !== "undefined") {
                    angular.forEach(model.groups, function (groupRow) {
                        if (groupRow.WFGroupId == defaultVal) {
                            model.newPatternSeason.selectedGroup = groupRow;
                        }
                    });
                }
            });
        }

        function getDevelopmentTypeList() {
            PatternService.getDevelopmentTypeList(true).then(function (data) {
                model.developmentTypeList = data;
            });
        }

        function getProductLineList() {
            PatternService.getProductLineList().then(function (data) {
                model.productLineList = data;
            });
        }

        model.checkPatternName = function () {
            var patternName = model.newPatternSeason.patternName;
            if (model.newPatternSeason.selectedBrand && model.newPatternSeason.selectedSeason && patternName) {
                toaster.clear();
                PatternService.isPatternNameExists(0, patternName, model.newPatternSeason.selectedBrand, model.newPatternSeason.selectedSeason)
                    .then(function (response) {
                        if (response == true) {
                            toaster.pop({
                                type: 'note',
                                title: 'Name duplication',
                                body: 'You may continue, but please note this name already exists.',
                                timeout: 5000
                            });
                        }
                    });
            }
        };

        model.selectBrand = function (brandId) {
            model.newPatternSeason.Responsible = '';

            model.isDisabled = !brandId;

            getSeasonsByBrand(brandId);
            getUsersByBrand(brandId);
            getWFGroups(brandId);
            model.loadBriefs(true);
            model.checkPatternName();
        };

        model.setWindowGridHeight = function () {
            if (window.innerHeight >= 768) {
                $scope.windowGridHeight = window.innerHeight - 581;
            } else if ($scope.pagerData) {
                var size = $scope.pagerData.TotalRecords < $scope.pagerData.PageSize ? $scope.pagerData.TotalRecords : $scope.pagerData.PageSize;
                $scope.windowGridHeight = (size * 12) + 46;
            }
        };

        model.resetFilter = function () {
            model.briefId = 0;
            model.radioValue = 0;
            $scope.filterText = "";
        };

        model.getActiveBrandId = function () {
            if (model.briefSeasonalId > 0) {
                return model.briefDetails.BrandId;
            }

            if (model.parentPatternSeasonalId > 0) {
                return model.patternDetails.BrandId;
            }

            return model.newPatternSeason.selectedBrand;
        };

        model.loadBriefs = function (resetFilter) {
            if (resetFilter) {
                model.resetFilter();
            }

            var seasonId = model.newPatternSeason.selectedSeason ? model.newPatternSeason.selectedSeason : 0;

            if (seasonId === 0) {
                return;
            }

            var brandId = model.getActiveBrandId();

            model.getBriefsByBrandSeason(brandId, seasonId);
        };

        $scope.validateAccountable = function (obj, prop) {
            if (!obj) return;

            prop = prop || "Responsible";

            //If its not an object or doesn't have the correct property theres nothing we can do.
            if (typeof obj !== "object" || !obj.hasOwnProperty(prop)) {
                return;
            }

            //If it doesn't look like a user (has an Id property with a value > 0) we will set the prop to null;
            //Otherwise it will pass.
            if (!obj[prop].hasOwnProperty("Id") || obj[prop].Id <= 0) {
                obj[prop] = null;
            }
        };

        model.setBrief = function (selectedBriefId, briefStatusId, item) {
            if (briefStatusId == 2 || briefStatusId == 3) {
                model.briefId = selectedBriefId;
                model.radioValue = model.briefId;
                model.selectedItem = item;
            }
        };

        model.loadBriefsPage = function (pageNumber, pageSize) {
            model.pageNumber = pageNumber;
            model.pageSize = pageSize;
            model.loadBriefs(false);
        };

        model.getBriefsByBrandSeason = function (brandId, seasonId, briefId, autoSelect) {

            if (!model.pageNumber)
                model.pageNumber = 1; //set page number to one immediately on change

            var searchObject = {
                BrandId: brandId,
                SeasonId: seasonId,
                BriefId: briefId,
                StatusId: 2,
                StatusIdSecondary: 3,
                BriefName: $scope.filterText,
                SortColumn: 'BriefName',
                SortDirection: 'Asc'
            };

            $scope.gridLoading = true;
            model.autoSelect = autoSelect;

            BriefService.searchBriefs(searchObject, model.pageNumber, model.pageSize).then(function (response) {
                $scope.gridLoading = false;
                if (response.results) {
                    model.briefs = response;

                    //build pagerdata without results
                    $scope.pagerData = {
                        CurrentPageNumber: model.briefs.currentPage,
                        PageSize: model.briefs.pageSize,
                        TotalPageCount: model.briefs.totalPages,
                        TotalRecords: model.briefs.totalRecords,
                        firstRecord: model.briefs.firstRecord,
                        lastRecord: model.briefs.lastRecord
                    };

                    ////if there is only one line plan then select and hightlight the row
                    if (response.results.length == 1 && !model.autoSelect) {
                        if (response.results[0].StatusId == 2) {
                            model.setBrief(response.results[0].BriefId,
                                response.results[0].StatusId,
                                response.results[0]);
                        }
                    }

                    model.setWindowGridHeight();
                } else {
                    model.briefs = "";
                }
            });
        };

        //Invoke functions based on create or copy mode
        if (model.briefSeasonalId == 0 && model.parentPatternSeasonalId == 0) {
            getBrands();
            getDevelopmentTypeList();
            getProductLineList();
        }

        if (model.briefSeasonalId > 0) {

            BriefService.getBriefCreateDetails(model.briefSeasonalId).then(function (createDetails) {

                model.users = createDetails.users;

                model.briefDetails = createDetails.briefDetails;

                var briefId = model.briefDetails.BriefId;
                var brandId = model.briefDetails.BrandId;

                model.briefId = briefId;

                model.newPatternSeason.selectedBrand = brandId;
                model.isDisabled = false;

                model.getBriefsByBrandSeason(brandId, model.briefDetails.SeasonId, briefId);
                getDevelopmentTypeList();
                getProductLineList();
                getWFGroups(brandId);
                cfpLoadingBar.complete();
            });
        }

        //copy pattern
        if (model.parentPatternSeasonalId > 0) {
            //Get pattern Details
            PatternService.getPatternSeasonalDetails(model.parentPatternSeasonalId).then(function (patternSeasonalDetails) {
                model.patternSeasonalDetails = patternSeasonalDetails;
                model.parentPatternId = model.patternSeasonalDetails.PatternId;
                PatternService.getPatternDetails(model.parentPatternId).then(function (patternDetails) {
                    model.patternDetails = patternDetails;
                    model.newPatternSeason.selectedBrand = model.patternDetails.BrandId;
                    model.isDisabled = false;
                    getUsersByBrand(model.patternDetails.BrandId);
                    getWFGroups(model.patternDetails.BrandId, patternSeasonalDetails.WFGroupId);
                    getSeasonsByBrand(model.patternDetails.BrandId, patternSeasonalDetails.SeasonId);
                });

                getDevelopmentTypeList();
                getProductLineList();
            });
        }

        model.createPatternSeason = function (isFormInvalid) {
            if (!isFormInvalid && model.briefId) {
                $scope.patternCreateForm.$setPristine();
                var getBrandId = "";
                var getSeasonId = "";

                if (model.briefSeasonalId == 0 && model.parentPatternSeasonalId == 0) {
                    getBrandId = model.newPatternSeason.selectedBrand;
                    getSeasonId = model.newPatternSeason.selectedSeason;
                }

                if (model.parentPatternSeasonalId > 0) {
                    getBrandId = model.patternDetails.BrandId;
                    getSeasonId = model.newPatternSeason.selectedSeason;
                }

                if (model.briefSeasonalId > 0) {
                    getBrandId = model.briefDetails.BrandId;
                    getSeasonId = model.briefDetails.SeasonId;
                }

                var patternEstCompletionDate = "";
                if (model.newPatternSeason.EstCompleteDate) {
                    patternEstCompletionDate = $filter('date')(model.newPatternSeason.EstCompleteDate, "M/dd/yyyy");
                }

                //set pattern data into pattern object from form fields
                model.patternData = {
                    BriefId: model.briefId,
                    patternName: model.newPatternSeason.patternName,
                    BrandId: getBrandId, //ImageName: "", OutsoleImageName: "",
                    EstCompleteDate: patternEstCompletionDate,
                    ProductLine: model.newPatternSeason.ProductLine,
                    GenderKey: model.GenderKey,
                    Gender: model.Gender
                };

                //set pattern seasonal data into patternseasonal object from form fields
                model.patternSeasonalData = {
                    CopySeasonalId: model.parentPatternSeasonalId,
                    SeasonId: getSeasonId,
                    StatusId: 1,
                    ResponsibleId: model.newPatternSeason.Responsible.Id,
                    WFGroupId: model.newPatternSeason.selectedGroup.WFGroupId,
                    DevelopmentType: model.newPatternSeason.DevelopmentType,
                    IsNew: true
                };

                PatternService.createPatternSeasonal(model.patternData, model.patternSeasonalData, model.briefId)
                    .then(function (response) {
                        if (response.IsSuccessful) {
                            $state.go("pattern", { patternSeasonalId: response.Data.PatternSeasonalId });
                            toaster.pop({
                                type: 'success',
                                title: 'Success!',
                                body: 'Pattern ' + model.parentPatternSeasonalId > 0 ? "Copied" : "Created" + ' successfully.',
                                timeout: 5000
                            });
                        }
                        else {
                            toaster.pop({
                                type: 'error',
                                title: 'Error!',
                                body: response.Message,
                                timeout: 5000
                            });
                            $scope.patternCreateForm.$setPristine();
                            $scope.patternCreateForm.$setUntouched();
                        }
                    }, function (error, status) {
                        $scope.patternCreateForm.$setPristine();
                        $scope.patternCreateForm.$setUntouched();
                        toaster.pop({
                            type: 'error',
                            title: 'Error!',
                            body: error,
                            timeout: 5000
                        });
                    });
            } else {
                $scope.patternCreateForm.$setPristine();
                var validation1 = isFormInvalid ? "Please review all fields indicated in red." : "";
                var validation2 = !model.briefId ? (validation1 !== "" ? " And " : "") + "Select a Brief that is in Released Status." : "";

                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: validation1 + validation2,
                    timeout: 4000
                });
            }
        };
    }
})();
